import { memo } from 'react';

import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { FieldContainerStyled, TextareaStyled } from './WireTransactionDescription.styles';

const WireTransactionDescription = ({ title, value, placeholder, maxLength, onBlur, disabled }) => (
  <Stack spacing="8px">
    <Text
      size="md"
      weight="medium"
    >
      {title}
    </Text>
    <FieldContainerStyled>
      <Stack spacing="16px">
        <TextareaStyled
          aria-label="transaction description"
          defaultValue={value}
          disabled={disabled}
          isValid={!!value}
          maxLength={maxLength}
          minRows={2}
          onBlur={onBlur}
          placeholder={placeholder}
        />
      </Stack>
      {maxLength && (
        <Box ml="12px">
          <Text
            color={value ? 'primary' : 'red'}
            size="sm"
          >
            {value ? `${maxLength} characters max` : 'Required'}
          </Text>
        </Box>
      )}
    </FieldContainerStyled>
  </Stack>
);

WireTransactionDescription.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool
};

WireTransactionDescription.defaultValue = {
  placeholder: '',
  maxLength: 0,
  value: '',
  disabled: false
};

export default memo(WireTransactionDescription);
